export default __webpack_public_path__ + "static/media/close_1.a4ca37cd.svg";